import React from 'react';
import { MapPin, Mail, Phone } from 'lucide-react';
import { companyInfo } from '../mock';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-br from-gray-900 via-slate-900 to-gray-900 text-white">

      <div className="container mx-auto px-4 py-16">

        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Contact Us
          </h2>

          <div className="w-24 h-1 bg-sky-500 mx-auto rounded-full"></div>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center max-w-4xl mx-auto">

          {/* Logo Section */}
          <div className="flex justify-center md:justify-end">

            <div className="flex items-center justify-center">

              <img
                src="https://kancalawas.com/uploads/logo1.png"
                alt="Logo"
                className="w-40 h-16 object-contain transition-transform duration-300 hover:scale-105"
              />

            </div>

          </div>

          {/* Contact Info */}
          <div className="space-y-4">

            <h3 className="text-2xl font-bold mb-6 text-sky-400">
              {companyInfo.name}
            </h3>

            <div className="flex items-start space-x-3 group">

              <MapPin className="w-5 h-5 text-sky-400 mt-1 flex-shrink-0 group-hover:scale-110 transition-transform" />

              <div>
                <p className="text-gray-300">
                  {companyInfo.contact.address}
                </p>

                <p className="text-gray-300">
                  {companyInfo.contact.street}
                </p>

                <p className="text-gray-300">
                  {companyInfo.contact.city}
                </p>
              </div>

            </div>

            <div className="flex items-center space-x-3 group">

              <Mail className="w-5 h-5 text-sky-400 flex-shrink-0 group-hover:scale-110 transition-transform" />

              <a
                href={`mailto:${companyInfo.contact.email}`}
                className="text-gray-300 hover:text-sky-400 transition-colors"
              >
                {companyInfo.contact.email}
              </a>

            </div>

            <div className="flex items-center space-x-3 group">

              <Phone className="w-5 h-5 text-sky-400 flex-shrink-0 group-hover:scale-110 transition-transform" />

              <a
                href={`tel:${companyInfo.contact.phone}`}
                className="text-gray-300 hover:text-sky-400 transition-colors"
              >
                {companyInfo.contact.phone}
              </a>

            </div>

          </div>

        </div>

      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-800">

        <div className="container mx-auto px-4 py-6">

          <p className="text-center text-gray-400 text-sm">
            © {new Date().getFullYear()} {companyInfo.name}. All rights reserved.
          </p>

        </div>

      </div>

    </footer>
  );
};

export default Footer;